// src/components/Glossary.js
import React, { useState } from 'react';
import { 
  Typography, 
  Container, 
  Box, 
  TextField, 
  Paper, 
  Divider, 
  Breadcrumbs,
  Link as MuiLink 
} from "@mui/material";
import { Link } from "react-router-dom";
import { keywordsData } from './KeywordData.js'; // Assicurati che il percorso sia corretto

const Glossary = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredKeywords = keywordsData.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* Navigazione breadcrumb per tornare alla home */}
      <Breadcrumbs sx={{ mb: 3, color: "#b88aff" }}>
        <MuiLink component={Link} to="/" sx={{ color: "#b88aff", textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
          Search
        </MuiLink>
        <Typography color="#f2f2f2">Glossary</Typography>
      </Breadcrumbs>

      <Typography variant="h3" gutterBottom sx={{ color: "#b88aff", fontWeight: 'bold' }}>
        MTG Keywords Glossary
      </Typography>
      
      <Typography variant="body1" sx={{ color: "#f2f2f2", mb: 4 }}>
        A comprehensive guide to Magic: The Gathering mechanics and ability words. 
        Use the search bar below to quickly find a specific mechanic.
      </Typography>

      {/* Barra di Ricerca Stilizzata */}
      <TextField
        fullWidth
        label="Search Mechanic (e.g., Scry, Trample, Infect...)"
        variant="outlined"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          mb: 5,
          "& label.Mui-focused": { color: "#b88aff" },
          "& .MuiInputLabel-root": { color: "#b88aff" },
          "& .MuiOutlinedInput-root": {
            color: "#f2f2f2",
            backgroundColor: "#1a1a1a",
            "& fieldset": { borderColor: "#5c4eb9" },
            "&:hover fieldset": { borderColor: "#b88aff" },
            "&.Mui-focused fieldset": { borderColor: "#b88aff" }
          }
        }}
      />

      {/* Lista delle Keyword */}
      {filteredKeywords.length > 0 ? (
        filteredKeywords
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((kw, index) => (
            <Box key={index} sx={{ mb: 6 }}>
              <Typography variant="h4" sx={{ color: "#b88aff", mb: 1 }}>
                {kw.name}
              </Typography>
              
              {kw.exampleCard && (
                <Typography variant="subtitle2" sx={{ color: "#8871ed", mb: 1, fontStyle: 'italic' }}>
                  Example card: {kw.exampleCard}
                </Typography>
              )}

              <Typography variant="body1" sx={{ color: "#f2f2f2", lineHeight: 1.7, mb: 2 }}>
                {kw.description}
              </Typography>

              {kw.notes && (
                <Paper 
                  elevation={0} 
                  sx={{ 
                    p: 2, 
                    backgroundColor: "#1a1a1a", 
                    borderLeft: "4px solid #5c4eb9",
                    color: "#f2f2f2"
                  }}
                >
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    <strong>Note:</strong> {kw.notes}
                  </Typography>
                </Paper>
              )}
              <Divider sx={{ mt: 4, borderColor: "#333" }} />
            </Box>
          ))
      ) : (
        <Typography sx={{ color: "#f2f2f2", textAlign: 'center', mt: 4 }}>
          No mechanics found for "{searchTerm}". Try a different term.
        </Typography>
      )}
    </Container>
  );
};

export default Glossary;